import { apiRequest } from './client';
import type {
  ApproveVoidRequestInput,
  CreateVoidRequestInput,
  RejectVoidRequestInput,
  VoidRequestItem,
  VoidRequestListFilters,
  VoidRequestListResponse,
} from '../types/voidRequests';

const PATH = '/api/void-requests';

export const createVoidRequest = (input: CreateVoidRequestInput) => apiRequest<{ voidRequest: VoidRequestItem; message: string }>(PATH, json('POST', input));
export const getVoidRequests = (filters: VoidRequestListFilters = {}) => apiRequest<VoidRequestListResponse>(`${PATH}${toQuery(filters)}`);
export const getVoidRequest = (id: string) => apiRequest<{ voidRequest: VoidRequestItem }>(`${PATH}/${id}`);
export const approveVoidRequest = (id: string, input: ApproveVoidRequestInput) => apiRequest<{ voidRequest: VoidRequestItem; message: string }>(`${PATH}/${id}/approve`, json('POST', input));
export const rejectVoidRequest = (id: string, input: RejectVoidRequestInput) => apiRequest<{ voidRequest: VoidRequestItem; message: string }>(`${PATH}/${id}/reject`, json('POST', input));
export const cancelVoidRequest = (id: string) => apiRequest<{ voidRequest: VoidRequestItem; message: string }>(`${PATH}/${id}/cancel`, { method: 'POST' });

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}

function toQuery(filters: object) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => { if (value !== undefined && value !== '') query.set(key, String(value)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = query.toString();
  return search ? `?${search}` : '';
}
